import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-modal-confirmado-envio-analise',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './modal-confirmado-envio-analise.html',
  styleUrl: './modal-confirmado-envio-analise.scss',
})
export class ModalConfirmadoEnvioAnalise {
    constructor(
    public dialogRef: MatDialogRef<ModalConfirmadoEnvioAnalise>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm() {
    this.dialogRef.close(true);
  }
}
